






import { Component, Prop, Vue } from 'vue-property-decorator';
import BTBConfig from '@/btb-conf.json';

@Component
export default class DateHeader extends Vue {
  now : (string | undefined) =  new Intl.DateTimeFormat(BTBConfig.courseInfo.localization, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' , hour: 'numeric',  minute: 'numeric', second: 'numeric' }).format(new Date()) 

  get date() {
    if(!this.now){
      this.now = new Intl.DateTimeFormat("en", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' , hour: 'numeric',  minute: 'numeric', second: 'numeric' }).format(new Date())
    }
    const date = this.now;
    return date;
  }
}
